import React, { useState, useEffect } from "react";
import axios from "axios";
import "../../../styles/pages-styles/main-dashboard-pages-styles/question-pages-styles/QuestionReview.css";
import ReviewHeader from "../../../components/question-components/ReviewHeader";

const QuestionReview = () => {
  const [reviewedQuestions, setReviewedQuestions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [filterType, setFilterType] = useState("allQuestions");
  const [allCategories, setAllCategories] = useState(["All"]); // Renamed to allCategories for clarity
  const userId = sessionStorage.getItem("userId");

  useEffect(() => {
    const fetchReviewData = async () => {
      setLoading(true);
      setError(null);
      console.log("user id is", userId);
      console.log("fetchReviewData called from frontend");
      try {
        const response = await axios.get(`/user/answered-questions/${userId}`);
        console.log("Review Data Response:", response.data);
        setReviewedQuestions(response.data.reviewedQuestions);
        setAllCategories(["All", ...response.data.categories]); // Set categories from the response
      } catch (err) {
        console.error("Error fetching review data:", err);
        setError(err.message || "Failed to fetch review data");
      } finally {
        setLoading(false);
      }
    };

    fetchReviewData();
  }, [userId]);

  const handleCategoryChange = (category) => {
    setSelectedCategory(category);
  };

  const filteredQuestions = reviewedQuestions.filter((questionItem) => {
    const question = questionItem.question;
    return (
      (selectedCategory === "All" || question?.category === selectedCategory) &&
      (filterType === "allQuestions" ||
        (filterType === "correct" && questionItem.isCorrect) ||
        (filterType === "incorrect" && !questionItem.isCorrect) ||
        (filterType === "flagged" && questionItem.flagged)) // Assuming flagged is present
    );
  });

  const getStatusIcon = (isCorrect) => {
    return <span className={`status-icon ${isCorrect ? 'correct' : 'incorrect'}`}>{isCorrect ? '✓' : '✗'}</span>;
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return new Intl.DateTimeFormat("en-US", { day: "numeric", month: "short" }).format(date);
  };

  if (loading) {
    return <div>Loading reviewed questions and categories...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <div>
      <ReviewHeader />
      <div className="medical-app">
        <div className="categories-panel">
          <ul className="categories-list">
            {allCategories.map((category) => (
              <li
                key={category}
                className={selectedCategory === category ? "selected" : ""}
              >
                <label>
                  <input
                    type="checkbox"
                    checked={selectedCategory === category}
                    onChange={() => handleCategoryChange(category)}
                  />
                  {category}
                </label>
              </li>
            ))}
          </ul>
          <div className="filter-buttons-container">
            <div className="filter-buttons-row">
              <button
                className={filterType === "allQuestions" ? "active" : ""}
                onClick={() => setFilterType("allQuestions")}
              >
                All questions
              </button>
              <button
                className={filterType === "incorrect" ? "active" : ""}
                onClick={() => setFilterType("incorrect")}
              >
                Incorrect
              </button>
              <button
                className={filterType === "correct" ? "active" : ""}
                onClick={() => setFilterType("correct")}
              >
                Correct
              </button>
            </div>
            <div className="filter-buttons-row">
              <button
                className={filterType === "allQuestions" ? "active" : ""}
                onClick={() => setFilterType("allQuestions")}
              >
                All questions
              </button>
              <button
                className={filterType === "flagged" ? "active" : ""}
                onClick={() => setFilterType("flagged")}
              >
                Flagged questions
              </button>
            </div>
          </div>
        </div>

        <div className="questions-panel">
          <table className="questions-table">
            <thead>
              <tr>
                <th>Date</th>
                <th>Question</th>
                <th>Explanation</th>
                <th>Status</th>
                <th>Review</th>
              </tr>
            </thead>
            <tbody>
              {filteredQuestions.map((item) => (
                <tr key={item._id} className="question-row">
                  <td className="date-column">
                    <div className="date">{formatDate(item.question.createdAt)}</div>
                  </td>
                  <td className="content-column">
                    <div className="question-title">{item.question.questionText}</div>
                  </td>
                  <td className="content-column">
                    <div className="question-explanation">{item.question.explanation}</div>
                  </td>
                  <td className="status-column">
                    {getStatusIcon(item.isCorrect)}
                  </td>
                  <td className="review-column">
                    <button className="review-button">View Details</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default QuestionReview;